import React from "react";
import { Link } from "@quintype/components";
import { number, string } from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";
import "./app-logo.m.css";

const AppLogo = ({ width = 80, height = 36, imgSrc, className = "", styleName = "" }) => {
  const publisherAttributes = useSelector((state) => get(state, ["qt", "config", "publisher-attributes"], {}));
  const publisherLogo = get(publisherAttributes, ["publisher-logo"]);
  const finalSrc = imgSrc || publisherLogo;

  return (
    <Link href="/" aria-label="app-logo" className={className} styleName={styleName}>
      <img
        src={finalSrc}
        alt="IMA India Logo"
        width={width}
        height={height}
        styleName="publisher-logo"
      />
    </Link>
  );
};

AppLogo.propTypes = {
  width: number,
  height: number,
  className: string,
  styleName: string,
  imgSrc: string
};
export { AppLogo };
